<template>
  <div class="banner">
    <el-col :span="24" class="action-bar">
      <!-- <span style="color:#888888;">轮播图管理:</span> -->
      <el-button type="primary" size="medium" @click="unitVisible=true" style="margin: 0 20px;">绑定单位</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="unitList" highlight-current-row class="el-table-style" v-loading="loading">
      <el-table-column align="center" type="index" width="50" label="序号"/>
      <el-table-column align="center" prop="date" label="logo">
        <template slot-scope="scope">
          <div>
            <img :src="scope.row.logo_url" alt="" style="width:60px;border-radius:50%;height:60px;object-fit:cover">
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" label="单位名称" />
      <el-table-column align="center" prop="name" label="单位分类" >
        <template slot-scope="scope">
          <div>
            <span v-for="(item,index) in scope.row.classify_Info"><span v-if="index!=0">、</span>{{item.classify_name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" label="单位地址" >
        <template slot-scope="scope">
          <div style="whiteSpace:nowrap;overflow:hidden;textOverflow:ellipsis;">
            {{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button type="danger" class="danger-btn" size="mini" @click="sectionClassifyUnBindUnit(scope.row.id)">解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="footer-bar">
      <div class="page-code">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageTotal"
          :page-size="limit"
          :current-page="page"
          @current-change="getSectionClassifyBindUnitList"
        >
        </el-pagination>
      </div>
    </el-col>

    <!--绑定单位-->
    <div>
      <el-dialog title="绑定单位" :visible.sync="unitVisible" width="70%" :before-close="handleClose">
       <div>
           <el-col :span="24" class="action-bar">
             <el-input style="width: 200px" v-model="unitForm.keyword" placeholder="请输入关键字"/>
             <el-select v-model="unitForm.classify_id"  clearable placeholder="单位分类" style="margin:0 20px;">
               <el-option
                 v-for="item in searchSortList"
                 :key="item.id"
                 :label="item.name"
                 :value="item.id">
               </el-option>
             </el-select>
             <el-button type="primary" size="medium"  style="margin: 0 20px;" @click="getUnitList(1)">检索</el-button>
             <el-button type="primary" size="medium"  style="margin: 0 20px;" @click="onChange">重置</el-button>
           </el-col>
           <el-table :data="providerList" ref="multipleTable" :row-key="(i) => i.id"   @select="selectionChange" v-loading="unitLoading">
             <el-table-column type="selection" width="55" :selectable="selectable" :reserve-selection="true"/>
             <el-table-column align="center" type="index" width="50" label="序号"/>
             <el-table-column align="center" prop="date" label="logo">
               <template slot-scope="scope">
                 <div>
                   <img :src="scope.row.logo_url" alt="" style="width:60px;border-radius:50%;height:60px;object-fit:cover">
                 </div>
               </template>
             </el-table-column>
             <el-table-column align="center" prop="name" label="单位名称" />
             <el-table-column align="center" prop="name" label="单位分类" >
               <template slot-scope="scope">
                 <div>
                   <span v-for="(item,index) in scope.row.classify_Info"><span v-if="index!=0">、</span>{{item.classify_name}}</span>
                 </div>
               </template>
             </el-table-column>
             <el-table-column align="center" prop="name" label="单位地址" >
               <template slot-scope="scope">
                 <div style="whiteSpace:nowrap;overflow:hidden;textOverflow:ellipsis;">
                   {{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}
                 </div>
               </template>
             </el-table-column>
           </el-table>
         <el-col :span="24" class="footer-bar">
           <div class="page-code">
             <el-pagination
               background
               layout="prev, pager, next"
               :total="unitPageTotal"
               :page-size="unitForm.limit"
               :current-page="unitPage"
               @current-change="getUnitList"
             >
             </el-pagination>
           </div>
         </el-col>
       </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sectionClassifyBindUnit">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {UPLOAD_IMG} from "@/api/index.js";
export default {

  data(){
    return{
     id:'',
      pageTotal:0,
      limit:10,
      page: 1,
      unitList:[],
      unitVisible:false,
      unitPageTotal:0,
      unitPage: 1,
      searchSortList:[],
      providerList:[],
      selectFrome:[],
      unitLoading:false,
      loading:false,
      unitForm:{
        keyword:'',
        classify_id:'',
        is_member_unit:1,
        limit: 10
      }
    }
  },
  mounted(){
    this.id = this.$route.query.id;
    this.getSectionClassifyBindUnitList()
    this.getUnitClassifyList()
    this.getUnitList()
  },
  methods:{
    onChange(){
      this.unitForm.keyword=''
      this.unitForm.classify_id=''
      this.getUnitList()
    },
    selectionChange(e){
      let list = [];
      e.map((item) => {
        list.push(item.id);
      });
      this.selectFrome = [...new Set(list)];
      console.log(this.selectFrome)
    },
    selectable(row, index) {
      // 判断当前行是否已经被选择，如果已选择则返回 false 以禁用多选框
      return !this.unitList.some(selectedRow => selectedRow.id === row.id);
    },
    //获取单位分类
    async getUnitClassifyList(){
      let params = {
        page: 1,
        limit: 999
      }
      const res = await this.$api.getUnitClassifyList(params);
      if (res.data.level == 'success'){
        this.searchSortList = res.data.data;
      } else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
    },
    //获取单位列表
    async getSectionClassifyBindUnitList(page){
      this.loading=true
      this.page = page || this.page;
      let params = {
        limit:this.limit,
        page: this.page,
        section_classify_id:this.id
      }
      const res = await this.$api.getSectionClassifyBindUnitList(params);
      if(res.data.level=='success'){
        let list = res.data.data;
        this.unitList = list;
        this.pageTotal = res.data.page_info.total
      }else{
        this.$message({
          message: res.data.message,
          type: 'warning'
        });
      }
      this.loading=false
    },
    // 绑定单位
    async sectionClassifyBindUnit(){
      let params={
        unit_id:this.selectFrome,
        section_classify_id:Number(this.id)
      }
      this.$confirm('是否绑定单位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const {data:{level,message}} =await this.$api.sectionClassifyBindUnit(params)
        if(level=='success'){
          this.getSectionClassifyBindUnitList()
          this.handleClose()
        }
        this.$message({
          type: level,
          message: message
        });
      }).catch(() => {

      });
    },
    // 获取服务商列表
    async getUnitList(unitPage){
      this.unitLoading=true
      this.unitForm.page=unitPage||this.unitPage
       const {data:{level,data,page_info,message}} = await this.$api.getUnitList(this.unitForm);
      if(level=='success'){
        this.providerList = data;
        this.unitPageTotal = page_info.total
      }else{
        this.$message({
          message: message,
          type: 'warning'
        });
      }
      this.unitLoading=false
    },
    handleClose(){
      this.unitVisible=false
    },
    // 栏目解绑单位
    async sectionClassifyUnBindUnit(id){
      this.$confirm('是否解绑单位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const {data:{level,message}} =await this.$api.sectionClassifyUnBindUnit({unit_id:id,section_classify_id:this.id});
        if(level=='success'){
         await this.getSectionClassifyBindUnitList()
        }
        this.$message({
          type: level,
          message: message
        });
      }).catch(() => {

      });
    }
  }
}
</script>
<style lang='scss' scoped>
.banner{
  .action-bar{
    background-color: #f2f2f2;
    height: 60px;
    margin: 10px 0px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 20px;
    .action-bar-input{
      width: 250px;
      margin-right: 14px;
    }
  }
  .el-table-style{
    width: 100%;
    border: 1px solid #f2f2f2;
  }
  .footer-bar{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    padding: 8px;
    margin: 10px 0px;
    box-sizing: border-box;
  }
  .dialog-footer{
    text-align: center;
  }
}
</style>

<style>
.el-pagination.is-background .el-pager li,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next
{
  background-color: #fff;
  border: 1px solid #f1f1f1;
  margin: 0;
}
.member .el-dialog__body{overflow: auto;}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/unit/unit_list.vue